<template>
  <div style="margin-top:10px;">
    <el-row align="bottom">
      <el-col :span="16">
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
          :page-size="pagesize" layout="prev,pager,next" :total="pageTotal">
        </el-pagination>
      </el-col>
    </el-row>
    <!-- <el-divider></el-divider> -->
    <el-table :data="tableData" @expand-change="tableChange" :expand-row-keys="expands" row-key="id" stripe border
      ref="table2" @selection-change="selectionChange">
      <el-table-column type="expand" prop="childdata" size="small">
        <span slot-scope="scopes">
          <!-- <el-table :data="orderProductArr" border align="center" stripe> -->
          <el-table :data="orderProductListMap[scopes.row.id]" border align="center" stripe>
            <el-table-column prop="warehouseUserName" label="供应商" width="200">
              <span slot-scope="scope">
                {{ scope.row.warehouseUserName }}
              </span>
            </el-table-column>
            <el-table-column prop="productName" label="图书名称" width="240" />
            <el-table-column prop="productSn" label="ISBN" width="200" />
            <el-table-column prop="marketPrice" label="定价" width="90" />
            <el-table-column prop="discount" label="折扣" width="90" />
            <el-table-column prop="shopPriceTotal" label="折扣价" width="90" />
            <el-table-column prop="productNumber" label="数量" width="90" />
            <el-table-column prop="productAssigned" label="已配送" width="90">
            </el-table-column>
            
            <el-table-column prop="prepareAssignNumber" label="预配送" width="90"/>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <span v-if="scopes.row.orderStatus==2">
                  订单已完成
                </span>
                <span v-else-if="scopes.row.orderStatus==-1">
                  订单已取消
                </span>
                <span
                  v-else-if="scopes.row.shippingStatus < 1 && scope.row.returnStatus == 0 && scope.row.backStatus == 0">
                  <el-tooltip class="item" effect="light" content="取消订单" placement="top">
                    <el-button size="mini" type="primary" round @click="cancelOrderProduct(scope.row)"
                      icon="el-icon-delete">
                    </el-button>
                  </el-tooltip>
                </span>
                <span v-else>
                  <el-tooltip class="item" effect="light" content="退款" placement="top">
                    <el-button round size="mini" type="danger" @click="handleReturn(scope.row)"
                      v-show="compTime(scopes.row.payTime)"
                      v-if="scope.row.returnStatus == 0 && (scope.row.productNumber - scope.row.returnBackNumber) > scope.row.productAssigned && scope.row.prepareAssignNumber <= 0">
                      退款
                    </el-button>
                    <span v-else-if="scope.row.returnStatus == 1">退款审批中</span>
                    <span v-else-if="scope.row.returnStatus == 2">已退款</span>
                    <el-button round size="mini" type="primary" @click="handleReturn(scope.row)"
                      v-else-if="scope.row.returnStatus == 3 && (scope.row.productNumber - scope.row.returnBackNumber) > scope.row.productAssigned">
                      重新申请退款
                    </el-button>
                  </el-tooltip> |
                  <el-tooltip class="item" effect="light" content="退货" placement="top"
                    v-if="scope.row.productAssigned >= 1">
                    <el-button size="mini" type="primary" round @click="handleBack(scope.row, scopes.row)"
                      v-if="scope.row.backStatus == 0">退货</el-button>
                    <span v-else-if="scope.row.backStatus == 1">退货审批中</span>
                    <span v-else-if="scope.row.backStatus == 2">已退货退款</span>
                    <el-button size="mini" type="primary" round @click="handleBack(scope.row, scopes.row)"
                      v-else-if="scope.row.backStatus == 3">重新申请退货</el-button>
                    <!-- <span v-else-if="scope.row.backStatus == 3">驳回退货</span> -->
                  </el-tooltip>
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div>
            <el-tag type="info" effect="plain">
              <b>收货人</b>：{{ scopes.row.consignee }}&#8195; <b>收货地址</b>：
              {{ scopes.row.provinceText }}
              {{ scopes.row.cityText }}
              {{ scopes.row.districtText }}&#8195;
              {{ scopes.row.address }}&#8195; <b>联系电话</b>：{{
              scopes.row.mobile
              }}&#8195;
            </el-tag>
          </div>
          <div>
            <el-tag type="info" effect="plain">
              <b>客户下单备注</b>：{{ scopes.row.payNote }}
            </el-tag>
          </div>
          <div>
            <el-tag type="info" effect="plain">
              <b>系统订单备注</b>：{{ scopes.row.remark }}
            </el-tag>
          </div>
          <div>
            <el-tag type="info" effect="plain">
              <b>包标</b>：{{ scopes.row.labelNote }}
            </el-tag>
          </div>
        </span>
      </el-table-column>
      <el-table-column align="center" width="45" label="全选" type="selection">
        <!--<template slot-scope="scope">
          <el-checkbox v-if="scope.row.payStatus === 2"  v-model="scope.row.selected" />
          <el-checkbox v-else v-model="scope.row.selected" @change="subtableSelectionChange(scope.row)" />
        </template>-->
      </el-table-column>
      <el-table-column align="center" label="订单编号">
        <template slot-scope="scope">
          <el-link :underline="false" @click="mergePayOrder(scope.row)">{{
            scope.row.orderSn
            }}</el-link>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="goodsAmount" label="数量" width="55"></el-table-column>
      <el-table-column align="center" prop="orderMoneyOriginal" width="65" label="定价">
      </el-table-column>
      <!-- <el-table-column
        align="center"
        prop="discount"
        label="折扣"
        width="60"
      ></el-table-column> -->
      <el-table-column align="center" prop="orderMoney" label="折扣价" width="70"></el-table-column>
      <el-table-column align="center" prop="expenses" label="运费" width="65"></el-table-column>
      <el-table-column align="center" prop="addTime" label="订单时间" width="110">
      </el-table-column>
      <el-table-column align="center" prop="orderStatus_dictText" label="订单状态" width="80"></el-table-column>
      <el-table-column align="center" prop="shippingStatus_dictText" label="发货状态" width="80"></el-table-column>
      <el-table-column align="center" label="付款状态" width="80">
        <template slot-scope="scope">
          {{ scope.row.payStatus_dictText }}
          <span v-if="scope.row.shippingStatus < 1">
            <el-tooltip class="item" effect="light" content="取消订单" placement="top">
              <el-button size="mini" type="primary" round @click="cancelOrder(scope.row)" icon="el-icon-delete">
              </el-button>
            </el-tooltip>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="shippingName" label="快递公司" width="120"></el-table-column>
      <el-table-column align="center" prop="shippingId" label="快递单号"></el-table-column>
    </el-table>
    <el-dialog title="退货申请" :visible.sync="dialogVisible" width="26%">
      <el-form ref="form" :model="backForm" label-width="80px">
        <el-form-item label="退货数量">
          <el-input v-show="false" v-model="backForm.id" />
          <el-input-number :min="1" :max="backNumberMax" v-model="backForm.backNumber"></el-input-number>
        </el-form-item>
        <el-form-item label="退货原因">
          <el-select v-model="backForm.backType" placeholder="请选择退货原因">
            <el-option label="质量问题" value="1"></el-option>
            <el-option label="其它" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运费">
          <el-radio v-model="backForm.expressFlag" label="1">包含运费</el-radio>
          <el-radio v-model="backForm.expressFlag" label="2">不包含运费</el-radio>
        </el-form-item>
        <el-form-item label="退货说明">
          <el-input type="textarea" v-model="backForm.backDesc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="backSubmit">申请退货</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAction, postAction } from "../../../api/index";
export default {
  name: "orderOn",
  inject: ['parentQueryParam'],
  data() {
    return {
      tableData: [],
      expands: [],
      multipleSelection: [],
      orderProductArr: [],
      queryParam: {
        isbn: "",
        orderSn: "",
        beginTime: "",
        endTime: "",
      },
      backForm: {
        id: "",
        backNumber: "",
        backType: "",
        backDesc: "",
        backMoney: 0.0,
        expressFlag: '1',
      },
      url: {
        getorderLit: "/order/queryList",
        selectOrderProductByOrderId: "/order/selectOrderProductByOrderId",
        cancelOrder: "/order/cancelOrder",
        cancelOrderProduct: "/order/cancelOrderProduct",
        orderProductRefund: "/order/orderProductReturn",
        orderProductBack: "/order/orderProductBack",
        exportExcel: "/order/exportExcel",
      },
      currentPage: 1, // 当前页码
      pagesize: 10, // 每页显示的行数
      pageTotal: 0,
      dialogVisible: false,
      backNumberMax: 0,
      orderList: {},
      currBackRow:{},
      orderProductListMap:{},
    };
  },
  components: {},
  computed: {
    ...mapGetters(["isNaName"]),
  },
  mounted() {},
  created() {
    this.getOrderList(1);
  },
  methods: {
    compTime(payTime) {
      // console.log("payTime=========", payTime);
      // let a = payTime.split(" ");
      // let b = a[0].split("-");
      // let c = a[1].split(":");
      // let date = new Date(b[0], b[1], b[2], c[0], c[1], c[2]);
      let date = new Date(payTime);
      let now = new Date();
      // console.log("payTime=========", now.getTime() - (72 * 60 * 60 * 1000));
      // console.log("payTime=========", date.getTime());
      if (now.getTime() - (24 * 60 * 60 * 1000) > date.getTime()) {
        // console.log("payTime=========", true);
        return true;
      } else {
        // console.log("payTime=========", false);
        return false;
      }
    },
     selectionChange(row) {
        //  console.log("selectionChange========",row);
         this.multipleSelection = row;
         this.$emit('selectionChange',this.multipleSelection)
     },
    getOrderList(page, isbn, orderSn, beginTime, endTime, consignee, tel, haveRemarkFlag) {
      this.expands = []; // 默认不展开
      getAction(this.url.getorderLit, {
        pageNo: page,
        orderStatus: 1,
        userId: this.$store.state.userInfo.id,
        isbn: isbn,
        orderSn: orderSn,
        createTime_begin: beginTime,
        createTime_end: endTime,
        consignee: consignee,
        tel: tel,
        haveRemarkFlag: haveRemarkFlag,
      }).then((res) => {
        if (res.data.success) {
          console.log("res.data===============", res.data);
          // if (orderList && orderList.length > 0){
          //   orderList..forEach(function (item) {
          //     if (item === 3) {
          //       return;
          //     }
          //     console.log(item);
          //   });
          // }
          this.orderProductListMap = res.data.result.orderProductListMap;
          this.tableData = res.data.result.orderListPage.records;
          this.pageTotal = res.data.result.orderListPage.total;
          this.expands = res.data.result.expands;
        }
      });
    },
    onOpenOrderRowInfo(f){
      const that = this
      if(f){
        that.tableData.forEach((row) => {
          let id = row.id;
          that.expands.push(id);
          that.selectOrderProductByOrderId(id)
        });
      }
    },
    tableChange(row) {
      //订单展开，查询订单里的产品信息
      var that = this;
      if (!this.orderProductListMap[row.id]){
        that.expands.push(row.id); // 每次push进去的是每行的ID
      }
      // if (expandedRows.length) {
      //   that.expands = [];
      //   if (row) {
      //     that.expands.push(row.id); // 每次push进去的是每行的ID
      //   }
      // } else {
      //   that.expands = []; // 默认不展开
      // }
      this.selectOrderProductByOrderId(row.id);
    },
    selectOrderProductByOrderId(id){
      let that = this;
      getAction(this.url.selectOrderProductByOrderId, {
        id: id, 'productSn': this.parentQueryParam.isbn,
        userId: this.$store.state.userInfo.id }).then(
        (res) => {
          if (res.data.success) {
            that.orderProductArr = res.data.result;
            // this.orderProductArr.forEach(item => {
            that.orderProductListMap[id] = res.data.result;
            // });
            // console.log("tableChange===============",res.data.result)

            this.$nextTick(() => {
              //设置延迟执行
              that.$forceUpdate();
            });

          }
        }
      );
    },
    mergePayOrder(obj) {
      this.orderList = {};
      this.orderList = obj;

      this.$router.push({
        path: "/orderDetial",
        params: {
          orderList: this.orderList,
          orderStatus: 1,
        },
        name: "订单明细",
      });
    },
    cancelOrder(row) {
      this.$confirm("取消此订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getAction(this.url.cancelOrder, { id: row.id }).then((res) => {
            console.log("cancelOrder========res=",res);
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "订单已取消！",
              });
              this.loadList(1)
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
            }
          })
        })
        .catch(() => {
        });
    },
    cancelOrderProduct(row) {
      this.$confirm("取消此订单商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getAction(this.url.cancelOrderProduct, { id: row.id }).then((res) => {
            console.log("cancelOrder========res=", res);
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "订单商品已取消！",
              });

              this.selectOrderProductByOrderId(row.orderId);
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
            }
          })
        })
        .catch(() => {
        });
    },
    loadList(pageNo){ // 第几页
      let isbn = this.parentQueryParam.isbn;
      let orderSn = this.parentQueryParam.orderSn;
      let createTime_begin = this.parentQueryParam.beginTime;
      let createTime_end = this.parentQueryParam.endTime;
      let consignee = this.parentQueryParam.consignee;
      let tel = this.parentQueryParam.tel;
      let haveRemarkFlag = this.parentQueryParam.haveRemarkFlag;
      this.getOrderList(pageNo, isbn, orderSn, createTime_begin, createTime_end, consignee, tel, haveRemarkFlag);
    },
    // 页面切换方法
    handleCurrentChange(val) {
      this.loadList(val);
      this.currentPage = val;
    },
    handleReturn(row) {
      this.$confirm((row.prepareAssignNumber > 0 ? "此订单已预配送，":"") + "退款订单将要扣除对应的积分, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getAction(this.url.orderProductRefund, { id: row.id }).then((res) => {
            if (res.data.success) {
              row.returnStatus = 1;
              this.$message({
                type: "success",
                message: "订单已申请退款，等待管理员处理您的退款申请！",
              });
              // this.getOrderRefundList(1);
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    handleBackFun(row, orderRow) {
      if (orderRow.expenses == 0) {
        this.backForm.expressFlag = '2';//不包含运费
      } else {
        this.backForm.expressFlag = '1';//包含运费
      }
      //退货
      this.dialogVisible = true;
      this.backForm.backNumber = 1;
      this.backForm.id = row.id;
      this.backNumberMax = row.productAssigned;
      this.currBackRow = row;
    },
    handleBack(row, orderRow) {
      if (row.prepareAssignNumber > 0 && row.prepareAssignNumber > row.productAssigned) {
        this.$confirm("此订单已预配送，是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.handleBackFun(row, orderRow);
        })
      } else { 
        this.handleBackFun(row, orderRow);
      }


    },
    backSubmit() {
      if (!this.backForm.backType) {
        this.$message.warning("请选择退货原因！");
        return;
      }
      console.log("this.currBackRow==========", this.backForm);
      postAction(this.url.orderProductBack, this.backForm).then((res) => {
        if (res.data.success) {
          this.currBackRow.backStatus = 1;
          this.$message.success("退货申请成功，等待管理员处理您的退货申请！");
          this.dialogVisible = false;
        }
      });
    },
    subtableSelectionChange(row) {
      this.multipleSelection.push(row.id);
    },
    toogleExpand(row) {
      let $table = this.$refs.table2;
      $table.toggleRowExpansion(row);
      console.log(this.$route.params.taskId);
    },
  },
};
</script>

<style lang="scss" scoped>



/*2.展开按钮未点击的样式是加号带边框*/
::v-deep .el-table__expand-icon .el-icon-arrow-right:before {
  color: #000;
  font-size: 18px;
}



$mainColor: #5cadff;
.contentTitle {
  h1 {
    font-weight: normal;
    font-size: 30px;
    color: #757575;
  }
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  line-height: 36px;
  background: #e5e9f2;
}
.demo-form-inline {
  margin-top: 1%;
}
// .el-col-2{
//     text-align: right !important;
// }
.el-divider {
  margin: 7px 0 !important;
}
.option {
  ul.category {
    float: left;
    height: 22px;
    padding: 10px 0;
    li {
      float: left;
      a {
        font-size: 16px;
        color: #757575;
        &:hover {
          color: $mainColor;
        }
      }
      span {
        margin: 0 20px;
      }
      &:last-child {
        span {
          display: none;
        }
      }
      &.active {
        a {
          color: $mainColor;
        }
      }
    }
  }
}
.header-search {
  float: right;
  form {
    position: relative;
    .searchPart {
      float: left;
      width: 245px;
      height: 50px;
      transition: all linear 0.2s 0s;
      border: 1px solid #e0e0e0;
      border-right: 0;
      box-sizing: border-box;
      input {
        width: calc(100% - 10px);
        height: 100%;
        outline: none;
        padding: 0 0 0 10px;
        &::-webkit-input-placeholder {
          color: #757575;
        }
      }
    }
    &:hover {
      .searchPart {
        border-color: #b0b0b0;
      }
      .sumbitPart {
        button {
          border-color: #b0b0b0;
        }
      }
    }
    .sumbitPart {
      float: left;
      button {
        cursor: pointer;
        width: 50px;
        height: 50px;
        border: 1px solid #e0e0e0;
        box-sizing: border-box;
        background-color: #fff;
        transition: all linear 0.2s 0s;
        span {
          color: #616161;
          font-size: 20px;
        }
      }
      &:hover {
        button {
          background-color: $mainColor;
          border: 1px solid $mainColor;
          span {
            color: #fff;
          }
        }
      }
    }
  }
}



</style>
